(function() {
  'use strict';

  angular.module('app.mail')
    .factory('Mail', Mail);

  function Mail($http) {
    let url = '/api/v1/mail',

    service = {
        send: send
    };

    return service;

    // Load a specific permit
    function send(to, from, subject, html) {
      return $http.post(url, {
          to: to,
          from: from,
          subject: subject,
          html: html
        })
        .then(function(response) {
          return response;
        })
        .catch(function(error) {
          console.error(error);
        });
    }
  }
})();
